import React from "react"
import { Link } from "gatsby"

import Layout from "../components/bs/layout"
//import Image from "../components/image"
import SEO from "../components/bs/seo"

import MainImg from "../images/main_bg.jpg"

import shape1 from "../images/dec/1.png"
import shape2 from "../images/dec/2.png"
import shape3 from "../images/dec/3.png"
import shape4 from "../images/dec/4.png"
import shape5 from "../images/dec/5.png"
import shape6 from "../images/dec/6.png"
import shape7 from "../images/dec/7.png"
import shape8 from "../images/dec/8.png"

const Partner = () => (
  <Layout>
    <SEO title="IMMMUNO NATURA - POSTANITE PARTNER" />

    <section
      id="_heroPage"
      className="hero is-large"
      style={{ backgroundImage: `url(${MainImg})` }}
    >
      <div id="bgHero">
        <span className="shape1">
          <img src={shape1} alt="Shape 1" />
        </span>
        <span className="shape2">
          <img src={shape2} alt="Shape 2" />
        </span>
        <span className="shape3">
          <img src={shape3} alt="Shape 3" />
        </span>
        <span className="shape4">
          <img src={shape4} alt="Shape 4" />
        </span>
        <span className="shape5">
          <img src={shape5} alt="Shape 5" />
        </span>
        <span className="shape6">
          <img src={shape6} alt="Shape 6" />
        </span>
        <span className="shape7">
          <img src={shape7} alt="Shape 7" />
        </span>
        <span className="shape8">
          <img src={shape2} alt="Shape 8" />
        </span>
      </div>
      <div className="hero-body">
        <div className="container">
          <div className="title">POSTANI PARTNER</div>
        </div>
      </div>
    </section>

    <span className="_line" />

    <section id="_pageContent_other" className="section">
      <span className="_dec2">
        <img src={shape8} alt="Dec 2" />
      </span>
      <div className="container">
        <div className="columns">
          <div className="column is-8 is-offset-2">
            <div className="columns">
              <div className="column is-6 _headline">
                <p className="subtitle is-4">
                  Volite prirodu i prirodne proizvode? Želite svoj poslovni dan
                  provoditi sa onim što volite?
                </p>
                <p className="content">
                  <strong>IMMMUNO NATURA tim se raduje novim kolegama.</strong>
                </p>
                <p className="content">
                  Kontaktirajte nas za više informacija. Radujemo se Vašem upitu
                  i odgovaramo u roku od 24h radnim danima.
                </p>
              </div>
              <div className="column">
                <div className="_info">
                  <form
                    className="form"
                    name="bs-postani-partner"
                    method="POST"
                    data-netlify="true"
                    data-netlify-honeypot="bot-field"
                    action="/postani-partner-hvala"
                  >
                    <input type="hidden" name="form-name" value="contact" />
                    <div className="_inner">
                      <span>Poslovni upit</span>

                      <div className="field">
                        <div className="control">
                          <input
                            className="input"
                            type="text"
                            name="name"
                            placeholder="Ime i prezime"
                            required
                          />
                        </div>
                      </div>
                      <div className="field">
                        <div className="control">
                          <input
                            className="input"
                            type="text"
                            name="email"
                            placeholder="Email"
                            required
                          />
                        </div>
                      </div>
                      <div className="field">
                        <div className="control">
                          <textarea
                            className="textarea"
                            name="message"
                            placeholder="Vaša poruka"
                            required
                          />
                        </div>
                      </div>
                      <label className="checkbox">
                        <input type="checkbox" required />
                        Slažem se sa{" "}
                        <a href="#">
                          uslovima i pravilima o zaštiti ličnih podataka
                        </a>
                      </label>
                    </div>
                    <div className="_buttonShop">
                      <button type="submit" class="button _kontaktBtn">
                        POŠALJI UPIT
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <span className="_dec3">
        <img src={shape6} alt="Dec 3" />
      </span>
    </section>
  </Layout>
)

export default Partner
